import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/en/contact", "en", "contact");
